'use-strict'
export const SELECT_RESOURCE = 'SELECT_RESOURCE'
export const UPDATE_SELECTED_RESOURCE = 'UPDATE_SELECTED_RESOURCE'
export const SELECT_RESOURCE_SECOND = 'SELECT_RESOURCE_SECOND'
export const ADD_RESOURCE_LIST_ITEM = 'ADD_RESOURCE_LIST_ITEM'
export const UPDATE_SELECTED_RESOURCE_SECOND = 'UPDATE_SELECTED_RESOURCE_SECOND'
export const TOGGLE_CHECK_ALL = 'TOGGLE_CHECK_ALL'
export const TOGGLE_CHECK_RESOURCE = 'TOGGLE_CHECK_RESOURCE'
export const CHANGE_LIST_PAGE = 'CHANGE_LIST_PAGE'
export const CLEAR_RESOURCES_STORE = 'CLEAR_RESOURCES_STORE'
export const SET_CONTEXT_FOOTER = 'SET_CONTEXT_FOOTER'
export const SET_CONTENT_LAST_URL = 'SET_CONTENT_LAST_URL'
export const SET_RESOURCE_LIST = 'SET_RESOURCE_LIST'
export const SET_TOTAL_NUMBER_OVERVIEW_LIST = 'SET_TOTAL_NUMBER_OVERVIEW_LIST'
export const SET_SECOND_RESOURCE_LIST = 'SET_SECOND_RESOURCE_LIST'
export const ADD_SECOND_RESOURCE_LIST_ITEM = 'ADD_SECOND_RESOURCE_LIST_ITEM'
export const REMOVE_SECOND_RESOURCE_LIST_ITEM = 'REMOVE_SECOND_RESOURCE_LIST_ITEM'
export const UPDATE_SECOND_RESOURCE_LIST = 'UPDATE_SECOND_RESOURCE_LIST'
export const UPDATE_RESOURCE_ITEM_IN_LIST = 'UPDATE_RESOURCE_ITEM_IN_LIST'
export const UNSELECT_RESOURCE = 'UNSELECT_RESOURCE'
export const IS_FETCHING_LIST = 'IS_FETCHING_LIST'
